import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryServiceType as LinkDeliveryServiceType } from '../links/DeliveryServiceType';
import { type CheckDeliveryAvailableResult as SchemaCheckDeliveryAvailableResult } from '../schemas/CheckDeliveryAvailableResult';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CheckDeliveryAvailableToNewDestinationContentType = '' as const;
export type CheckDeliveryAvailableToNewDestinationRequest = void;
export type CheckDeliveryAvailableToNewDestinationResponses = LinkCommonErrorResponses & {
    /**
     * @description Delivery availability check result
     */
    '200': {
        'application/json': SchemaCheckDeliveryAvailableResult;
    };
};
export type CheckDeliveryAvailableToNewDestinationResponseSuccess =
    CheckDeliveryAvailableToNewDestinationResponses['200']['application/json'];
export type CheckDeliveryAvailableToNewDestinationSearchParams = {
    address?: string;
    pickup_point_id?: string;
    pickup_point_service_type?: LinkDeliveryServiceType;
};
export type CheckDeliveryAvailableToNewDestinationPathParameters = {
    store_slug: string;
    order_id: string;
};
export const CheckDeliveryAvailableToNewDestinationUrl = '/{store_slug}/orders/{order_id}/delivery/available' as const;
export const CheckDeliveryAvailableToNewDestinationMethod = 'GET' as const;
export const getCheckDeliveryAvailableToNewDestinationUrl = (
    params: CheckDeliveryAvailableToNewDestinationPathParameters
) =>
    CheckDeliveryAvailableToNewDestinationUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof CheckDeliveryAvailableToNewDestinationPathParameters) => String(params[param])
    );
